module.exports = __webpack_public_path__ + "static/cover-61511ab8902fd50c99e34ba6f08184c5.png";